<template>
  <Service />
</template>

<script>
import Service from '@/views/Service';

export default {
  name: 'AltLayout',
  components: {
    Service,
  },
};
</script>

<style scoped></style>
